export default __webpack_public_path__ + "static/media/new-arrival.6e2eff39.svg";